import React from 'react';
import PropTypes from 'prop-types';
import {Heading} from '@tenancy.nz/design-system';
import {StyledBar} from './Styles';

function CustomHeading({barColor, children, ...rest}) {
  return (
    <Heading {...rest}>
      <StyledBar color={barColor}>{children}</StyledBar>
    </Heading>
  );
}

CustomHeading.propTypes = {
  /**
   * The right bar of before the text.
   */
  barColor: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * React component, HTML node or string
   */
  children: PropTypes.node.isRequired,
};

CustomHeading.defaultProps = {
  barColor: 'primary',
};

export default CustomHeading;
